<template>
  <job-filter></job-filter>
</template>

<script>
import store from "../../store/store";
import JobFilter from "./JobFilter";
import {Mixin} from "/src/mixins/index.js";

export default {
  name: "JobReport",
  mixins: [Mixin],
  components: {
    JobFilter
  },
  data() {
    return {};
  },

  methods: {},
  mounted() {
    store.commit("showLoader", false); // Loader Off
  },
};
</script>

